import { render, staticRenderFns } from "./planInfoLayout.vue?vue&type=template&id=ce8f4bc6&scoped=true"
import script from "./planInfoLayout.vue?vue&type=script&lang=js"
export * from "./planInfoLayout.vue?vue&type=script&lang=js"
import style0 from "./planInfoLayout.vue?vue&type=style&index=0&id=ce8f4bc6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8f4bc6",
  null
  
)

export default component.exports